/**
 * "Make master config from this container": names it; the container's
 * sections are copied onto it and the container follows it with nothing
 * overridden — the day it runs does not change.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';

import { ConfirmDialog } from '@/components/ui';

interface Props {
  open: boolean;
  containerName: string;
  busy: boolean;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

export const MakeMasterDialog: FC<Props> = ({ open, containerName, busy, onConfirm, onCancel }) => {
  const [name, setName] = useState(`${containerName} config`);
  return (
    <ConfirmDialog
      open={open}
      title={`Make the master config from ${containerName}?`}
      confirmLabel="Make master config"
      busy={busy}
      confirmDisabled={!name.trim()}
      onConfirm={() => onConfirm(name.trim())}
      onCancel={onCancel}
      description={
        <div className="flex flex-col gap-3 text-sm">
          <p>
            Its gateways, texts, send options, verdicts, hour optimizer, default amount and fail mode
            become the master config of its campaign. The container then follows it with nothing
            overridden, so today&apos;s plan does not change. Other containers on that campaign can follow
            it with one click.
          </p>
          <label className="flex flex-col gap-1 text-xs font-medium text-muted-foreground">
            Name of the master config
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={120}
              className="h-9 rounded-md border border-input bg-background px-3 text-sm text-foreground"
            />
          </label>
        </div>
      }
    />
  );
};
